import { render, staticRenderFns } from "./ApplicantAddress.vue?vue&type=template&id=1d1ca0a4&scoped=true&"
import script from "./ApplicantAddress.vue?vue&type=script&lang=js&"
export * from "./ApplicantAddress.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantAddress.vue?vue&type=style&index=0&id=1d1ca0a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1ca0a4",
  null
  
)

export default component.exports